import { render } from "./ConfFooter.vue?vue&type=template&id=3228f712"
import script from "./ConfFooter.vue?vue&type=script&lang=js"
export * from "./ConfFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__